module.exports = __webpack_public_path__ + "static/media/AsYouWalkonByBookJacket.01e344a3.jpg";